import { State as ProfileDetailsState } from '../reducers/profile-details-reducer';
import { Selector } from '@ngrx/store';
export const getIsActive: Selector<ProfileDetailsState, boolean> = (state: ProfileDetailsState) => state.isActive;
